export const NAMESPACE = 'wix.form_app.form';
